import { StorageKey } from "../../constants";

class CognitoAuthConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string = "code";
  scope: string = "email openid phone";

  constructor(init?: Partial<CognitoAuthConfig>) {
    Object.assign(this, init);
  }
}

export default CognitoAuthConfig;
export const _GET_AUTH_CONFIG = (domain: string): CognitoAuthConfig | null => {
  if (domain?.includes("trichy")) {
    localStorage.setItem(StorageKey.AuthUnion, "Trichy");
    localStorage.setItem(StorageKey.UnionId, "7");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_HFhsW9SfW",
      client_id: "30rttfvapq6sg98j5fjcq9t3ll",
      redirect_uri: "https://staff.trichy.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid profile",
    });
  } else if (domain?.includes("vellore")) {
    localStorage.setItem(StorageKey.AuthUnion, "Vellore");
    localStorage.setItem(StorageKey.UnionId, "8");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_8MSCy630p",
      client_id: "7mdfchangg1fjgmki82k3v82vb",
      redirect_uri: "https://staff.vellore.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("kallakurichi")) {
    localStorage.setItem(StorageKey.AuthUnion, "kallakurichi");
    localStorage.setItem(StorageKey.UnionId, "27");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_yn49n3Zaa",
      client_id: "2ncddvlc8re0u4bsetplikodue",
      redirect_uri: "https://staff.kallakurichi.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("thanjavur")) {
    localStorage.setItem(StorageKey.AuthUnion, "thanjavur");
    localStorage.setItem(StorageKey.UnionId, "16");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_UxRVMUoUM",
      client_id: "5vlnunugkc870vqv6mnbisttf4",
      redirect_uri: "https://staff.thanjavur.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("pudukkottai")) {
    localStorage.setItem(StorageKey.AuthUnion, "pudukkottai");
    localStorage.setItem(StorageKey.UnionId, "17");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_kIXj61yz0",
      client_id: "6p342j8c3lkgavih8uilrv2b1p",
      redirect_uri: "https://staff.pudukkottai.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("dindigul")) {
    localStorage.setItem(StorageKey.AuthUnion, "dindigul");
    localStorage.setItem(StorageKey.UnionId, "14");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_i5YFQvlbb",
      client_id: "3vrl6fvo3gcnsu88stoqgpds9g",
      redirect_uri: "https://staff.dindigul.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("villupuram")) {
    localStorage.setItem(StorageKey.AuthUnion, "villupuram");
    localStorage.setItem(StorageKey.UnionId, "9");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_hLu4DaST2",
      client_id: "6di0vmefrodjgh736bhqv7n8c2",
      redirect_uri: "https://staff.villupuram.dev.aavinsales.com",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else if (domain?.includes("ktunion")) {
    localStorage.setItem(StorageKey.AuthUnion, "kancheepuram");
    localStorage.setItem(StorageKey.UnionId, "15");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_Dz2LJHQDv",
      client_id: "5b59tn8i6akmrld625cbvh1gq4",
      redirect_uri: "https://staff.ktunion.dev.aavinsales.com/",
      response_type: "code",
      scope: "email openid phone profile",
    });
  } else {
    localStorage.setItem(StorageKey.AuthUnion, "dev"); //Devdb
    localStorage.setItem(StorageKey.UnionId, "101");
    return new CognitoAuthConfig({
      authority:
        "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_uHDVCj9ky",
      client_id: "4741ohv03oceamafslppvvag7u",
      redirect_uri: "http://localhost:3000",
      response_type: "code",
      scope: "email openid phone profile",
    });
  }
};


export const _GET_UNION_NAME = (domain: string): string | null => {
  if (domain?.includes("trichy")) {
    return "Trichy"
  } else if (domain?.includes("vellore")) {
    return "Vellore";
  } else if (domain?.includes("kallakurichi")) {
    return "Kallakurichi"
  } else if (domain?.includes("thanjavur")) {
    return "Thanjavur";
  } else if (domain?.includes("pudukkottai")) {
    return "Pudukkottai";
  } else if (domain?.includes("dindigul")) {
    return "Dindigul";
  } else if (domain?.includes("villupuram")) {
    return "Villupuram";
  } else if (domain?.includes("ktunion")) {
    return "Kancheepuram";
  } else {
   return "MacsIT.com pvt Ltd(Dev)"
  }
}